/* @flow */
import * as React from 'react';
import TeacherInfoCollectionModal from 'user/components/TeacherInfoCollectionModal';
import PromptActions from 'actions/PromptActions';
import { PromptNames } from 'constants/PromptConstants';
import { mountModal } from 'lib/modal';
import { includes } from 'lodash';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

type Props = {
  prompts: string[],
  loaded: boolean,
};

export class ProfileCompletenessModals extends React.Component<Props> {
  static defaultProps = {
    loaded: false,
  };
  componentDidMount() {
    if (this.props.loaded) {
      this.checkForPrompts();
    }
  }

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.loaded && this.props.loaded) {
      this.checkForPrompts();
    }
  }

  checkForPrompts() {
    let modal;
    if (includes(this.props.prompts, PromptNames.TEACHER_INFO_COLLECTION)) {
      modal = <TeacherInfoCollectionModal />;
      PromptActions.recordDismissal(PromptNames.TEACHER_INFO_COLLECTION);
    }

    if (modal) {
      mountModal(modal, this);
    }
  }

  render() {
    return null;
  }
}

const withPrompts = graphql(
  gql`
    query ProfileCompletenessPrompts {
      user: me {
        id
        uuid
        prompts_inventory {
          action
        }
      }
    }
  `,
  {
    props: ({ data }) => {
      return {
        loaded: !!data.user,
        prompts: data.user ? data.user.prompts_inventory.map(e => e.action) : [],
      };
    },
  }
);

export default withPrompts(ProfileCompletenessModals);
